import { Box } from "@mui/material";
import React from "react";
import styles from "./ActivityList.module.css";
import moment from "moment";
import redDot from "./assets/red-dot.svg";
import greenDot from "./assets/dot-green.svg";
import stageDot from "../../assets/images/stage-dot.svg";
import nameLine from "../../assets/images/name-line.svg";
import getTeamMember from "../CommonFunctions/CommonFunctions";

function ActivityeNACH(props: any) {
  const { data, employees } = props;

  return (
    <>
      <Box
        sx={{
          width: "100%",
          margin: "0 15px 22px 15px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className={styles.activityTop}>
            <div className={styles.activityDateStyle}>
              {moment(data?.creationDate).format("DD MMM YYYY, hh:mm A")}
            </div>
            <div className={styles.activityHeadStage}>
              <div className={styles.activityHeadStageIcon}>
                <img src={stageDot} alt="" />
              </div>
              <div>{data?.currentStage}</div>
            </div>
          </div>

          <div
            style={{
              color: " #142c44",
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "22px",
              marginBottom: "6px",
            }}
          >
            {data?.activityType === "UPI_AUTO_DEBIT_CANCELLED"
              ? "Easy EMI's Cancelled"
              : data?.activityType === "UPI_AUTO_DEBIT_ACTIVATED"
              ? "Easy EMI's Activated"
              : ""}
          </div>

          <div
            className={styles.activityStageDesc}
            style={{ display: "flex", alignItems: "center", gap: "5px" }}
          >
            <div
              style={{
                color: "#142c44",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "22px",
              }}
            >
              Easy EMI's status changed
            </div>
          </div>
        </Box>
      </Box>
    </>
  );
}

export default ActivityeNACH;
